import classes from "./Loader.module.css";

export default function Loader() {
  return (
    <>
      <span className={`${classes.loader}`}></span>
    </>
  );
}
